/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../nb');
var util = require('../../util');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.onChange('itemCode', function (inEvent, inItemCode) { //itemCode
                this.set('href', 'productDetail.html?itemCode=' +  encodeURI(inItemCode));  //转换字符串
            }, this, {before: true});

            this.onChange('price', function (inEvent, inPrice) {
                return '￥' + inPrice.toFixed(2); // util.numberFormat(inPrice / 100, 2)
            }, this, {before: true});
        }
    }
});

// this.onChange('id',function (inEvent,inId) { //itemCode
// this.set('href','productDetail.html?id='+inId);
// },this);


//////////////////
// WEBPACK FOOTER
// ../src/js/model/product/ProductItem.js
// module id = 73
// module chunks = 5 6 17 31 33 34